var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.clone
    ? _c(
        "div",
        { staticClass: "block-editor ai-classification payload" },
        [
          _c("div", { staticClass: "mode-selector" }, [
            _c("strong", [_vm._v("Sınıflandırma Modu:")]),
            _vm._v(" "),
            _c("div", { staticClass: "mode-buttons" }, [
              _c(
                "button",
                {
                  class: [
                    "mode-button",
                    { active: (_vm.clone.mode || "text") === "text" },
                  ],
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setMode("text")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("text_fields"),
                  ]),
                  _vm._v("\n                Text Mode\n            "),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  class: [
                    "mode-button",
                    { active: (_vm.clone.mode || "text") === "image" },
                  ],
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setMode("image")
                    },
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [_vm._v("image")]),
                  _vm._v("\n                Image Mode\n            "),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("strong", [
            _vm._v(_vm._s(_vm.$t("message.expressionClassified")) + ": "),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "says" },
            [
              _c("TiptapEditor", {
                key: "tiptap-prompt" + _vm.renderKey,
                attrs: {
                  "show-emoji": true,
                  "show-attributes": true,
                  placeholder:
                    "Ek talimatlar, özel koşullar veya sınıflandırmayı etkileyecek bilgiler (opsiyonel)",
                },
                model: {
                  value: _vm.clone.message,
                  callback: function ($$v) {
                    _vm.$set(_vm.clone, "message", $$v)
                  },
                  expression: "clone.message",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.isTextMode
            ? _c("div", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.$t("chatbotv2.aiClassificationImageUrlLabel")) +
                      ": "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "says" },
                  [
                    _c("TiptapEditor", {
                      key: "tiptap-image-url" + _vm.renderKey,
                      attrs: {
                        "show-emoji": false,
                        "show-attributes": true,
                        placeholder: "Image Url",
                      },
                      model: {
                        value: _vm.clone.imageUrl,
                        callback: function ($$v) {
                          _vm.$set(_vm.clone, "imageUrl", $$v)
                        },
                        expression: "clone.imageUrl",
                      },
                    }),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("strong", [
            _vm._v(_vm._s(_vm.$t("message.classification")) + ":"),
          ]),
          _vm._v(" "),
          _vm._l(_vm.clone.tags, function (tag, i) {
            return _c(
              "div",
              { key: tag.id || i, staticClass: "says" },
              [
                _c("TiptapEditor", {
                  key: "editor-" + (tag.id || i),
                  attrs: {
                    "show-emoji": true,
                    "show-attributes": true,
                    placeholder: _vm.$t("message.classification"),
                    value: tag.value || tag,
                  },
                  on: {
                    input: function ($event) {
                      return _vm.changeTags(i, $event)
                    },
                  },
                }),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: { danger: "", small: "" },
                    on: {
                      click: function ($event) {
                        return _vm.removeTag(i)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("delete"),
                    ]),
                  ]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c("a-divider"),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.addTag } },
            [
              _c("span", { staticClass: "material-icons" }, [_vm._v("add")]),
              _vm._v(" " + _vm._s(_vm.$t("message.classification"))),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }